<template>
  <div class="text">
    <ul class="editor-design">
      <li>
        {{ labelText }}
      </li>
      <li id="theme-style" class="flex-box">
        <!-- 背景色 -->
        <select-color
          :type="'section'"
          :target="targetProp('background')"
          :selector="null"
          :value="styles['background']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <li>
        <!-- 罫線 -->
        <div v-for="border in borders" :key="border.prop">
          <select-border
            :type="'section'"
            :value="border.style"
            :target="targetProp(border.prop)"
            @updateStyles="updateStyles($event)"
          />
        </div>
      </li>
      <!-- 余白（上下）-->
      <li class="flex-box">
        <slider
          :prop="'section_' + targetProp('padding-top')"
          :value="styles['paddingTop']"
          @updateStyles="updateStyles($event)"
          />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectBorder from '@/components/Content/Palette/CommonLayouts/EditStyleBorder'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'

export default {
  name: 'edit-design-container',
  data () {
    return {
      labelText: null,
      borders: [
        { prop: 'border-top', style: this.styles['borderTop'] },
        { prop: 'border-bottom', style: this.styles['borderBottom'] }
      ],
    }
  },
  props: [
    'sectionName',
    'sectionDisplayName',
    'target',
    'styles',
  ],
  components: {
    SelectColor,
    SelectBorder,
    Slider,
  },
  methods: {
    initLabelText () {
      switch (this.target) {
        case 'container':
          this.labelText = 'アウトライン'
          break
        case 'inner':
          this.labelText = this.sectionDisplayName
          break
        default:
          this.labelText = ''
      }
    },
    updateStyles (styles) {
      this.$store.commit('updateSectionStyles', {
        sectionName: this.sectionName,
        styles,
      })
    },
    targetProp (prop) {
      if (this.target === 'container') {
        return prop
      } else if (this.target === 'inner') {
        return 'inner_' + prop
      }
    },
  },
  watch: {
    'styles.borderTop' (value) {
      this.borders.find(border => border.prop === 'border-top').style = value
    },
    'styles.borderBottom' (value) {
      this.borders.find(border => border.prop === 'border-bottom').style = value
    },
  },
  mounted () {
    this.initLabelText()
  }
}
</script>

<style lang="scss">
#theme-style {
  .window {
    right: auto;
    left: 0;
  }
}
</style>
